// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../screens/Home/Home';
import Recipes from '../screens/Recipes/Recipes';
import RecipeFormScreen from '../screens/RecipeFormScreen/RecipeFormScreen';
import RecipeVariantFormScreen from '../screens/RecipeVariantFormScreen/RecipeVariantFormScreen';
import RecipeView from '../screens/Recipe/RecipeView';
import Saved from '../screens/Saved/Saved';
import GroceryList from '../screens/GroceryList/GroceryList';
import Admin from '../screens/Admin/Admin';
import MLAdmin from '../screens/MLAdmin/MLAdmin';
import ItemsAdmin from '../screens/ItemsAdmin/ItemsAdmin';
import DeveloperPortal from '../screens/DeveloperPortal/DeveloperPortal';
import Settings from '../screens/Settings/Settings';
import Onboard from '../screens/Onboard/Onboard';
import ShareableId from '../screens/ShareableId/ShareableId';
import PartnerProgram from '../screens/PartnerProgram/PartnerProgram';
import Pricing from '../screens/Pricing/Pricing';
import PasswordResetRequest from '../screens/PasswordReset/PasswordResetRequest';
import PasswordResetConfirm from '../screens/PasswordReset/PasswordResetConfirm';
import Terms from '../screens/Terms/Terms';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/recipes" element={<Recipes />} />
      <Route path="/saved" element={<Saved />} />
      <Route path="/grocery-list" element={<GroceryList />} />
      <Route path="/recipes/new" element={<RecipeFormScreen />} />
      <Route path="/recipes/:id/edit" element={<RecipeFormScreen />} />
      <Route path="/recipes/:id/view" element={<RecipeView />} />
      {/* Recipe Variant Routes */}
      <Route path="/recipes/:recipeId/customize" element={<RecipeVariantFormScreen />} />
      <Route path="/variants/:variantId/edit" element={<RecipeVariantFormScreen />} />
      <Route path="/variants/:variantId/view" element={<RecipeView />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/ml" element={<MLAdmin />} />
      <Route path="/admin/items" element={<ItemsAdmin />} />
      <Route path="/portal" element={<DeveloperPortal />} />
      <Route path="/portal/landing" element={<Home />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/onboard" element={<Onboard />} />
      <Route path="/id/:userId" element={<ShareableId />} />
      <Route path="/partner-program" element={<PartnerProgram />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/password-reset" element={<PasswordResetRequest />} />
      <Route path="/reset-password" element={<PasswordResetConfirm />} />
    </Routes>
  );
};

export default AppRoutes;
